import axios from "axios";

/**
 * Cookie-based session refresh. Returns response data or null on failure.
 */
export default async function silentRefresh(url) {
  try {
    const { data } = await axios.post(url, {}, { withCredentials: true, timeout: 15000 });
    return data;
  } catch {
    return null;
  }
}
